import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  errorContainer: {
    height: '200px',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ...shorthands.margin(tokens.spacingVerticalNone, tokens.spacingHorizontalXXL),
  },
  noDataContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase400,
    '& .loading-icon': {
      width: '104px',
    },
  },
  loadingContainerSmall: {
    fontSize: tokens.fontSizeBase100,
    '& .loading-icon': {
      width: '52px',
    },
  },
});
